var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.step && _vm.step.level)?_c('span',{staticClass:"text-nowrap"},[_c('b-badge',{attrs:{"variant":_vm.badgeVariant}},[_vm._v(" "+_vm._s(_vm.step.statusName || '')+" "+_vm._s(_vm.step.level)+" ")])],1):_c('span',[_vm._v("--")])
}
var staticRenderFns = []

export { render, staticRenderFns }